export default host => (clientId) => `${host}/clients/${clientId}`
